// ======================================================================
// File: src/modules/ppe/pages/procurement/grn/services/poLineLookupService.js
// Purpose: Lookup PO lines for selected Purchase Order
// ======================================================================

import axiosClient from "../../../../../../api/axiosClient";

const poLineLookupService = {

  search: async (poId, search) => {
    if (!poId) return [];

    const res = await axiosClient.get(
      `/api/ppe/material-flow/purchase-order/${poId}/lines`,
      {
        params: { search }
      }
    );

    // Handle { data: [...] } structure safely
    return res.data?.data || [];
  },

};

export default poLineLookupService;
